import { buildApiQueryHook, buildApiQueryNoParamsHook } from '@/utils/api';
import axios from 'axios';
import { BlogCategoryDto, BlogCategoryFullDto, BlogPostDto, BlogPostFullDto } from './blog.dto';

const url = process.env.NEXT_PUBLIC_BLOG_API_URL;
if (!url) throw new Error(`NEXT_PUBLIC_BLOG_API_URL must be set`);

const axiosBlog = axios.create({
  baseURL: url,
});

export const useBlogCategoriesQuery = buildApiQueryNoParamsHook<BlogCategoryDto[]>(
  'blog-categories',
  () => axiosBlog.get(`/categories`),
);

export const useBlogCategoryDetailsQuery = buildApiQueryHook<{ id: string }, BlogCategoryFullDto>(
  'blog-category',
  ({ id }) => axiosBlog.get(`/categories/${id}`),
);

export const useBlogPostsQuery = buildApiQueryHook<
  { categoryId?: string; skip?: number; take?: number },
  BlogPostDto[]
>('blog-posts', (params) => axiosBlog.get('/posts', { params }));

export const useBlogPostsCountQuery = buildApiQueryHook<{ categoryId?: string }, number>(
  'blog-posts-count',
  (params) => axiosBlog.get('/posts/count', { params }),
);

export const useBlogPostDetailsQuery = buildApiQueryHook<{ id: string }, BlogPostFullDto>(
  'blog-post',
  ({ id }) => axiosBlog.get(`/posts/${id}`),
);
